import { FC, useRef } from 'react'
import Flatpickr from 'react-flatpickr'

import SVGIcon from '../SVGIcon'

type DatePickerButtonProps = {
  enableTime?: boolean
  value: string
  onChange: (newVal: string) => void
  isBce: boolean
}

const DatePickerButton: FC<DatePickerButtonProps> = ({ value, enableTime = false, onChange, isBce }) => {
  const flatpickrRef = useRef<typeof Flatpickr.prototype | null>(null)
  const calendarValue = isBce ? '' : value

  // create a new element with id js-calendar-target in body, or grabs the existing one
  const getAppendToElement = () => {
    let appendToEl = document.getElementById('js-calendar-target')
    if (!appendToEl) {
      // create a new element with id js-calendar-target in body
      appendToEl = document.createElement('div')
      appendToEl.id = 'js-calendar-target'
      document.body.appendChild(appendToEl)
    }
    return appendToEl
  }
  const appendToEl = getAppendToElement()

  return (
    <div className="date-picker-button">
      <Flatpickr
        ref={flatpickrRef}
        value={calendarValue}
        onChange={(_, dateString) => onChange(dateString)}
        options={{
          appendTo: appendToEl,
          enableTime,
          altInput: true,
          altInputClass: 'date-picker-button__hidden-input',
          dateFormat: 'Y-m-d',
          disableMobile: true,
          animate: false,
        }}
      />
      <button
        className="date-picker-button__trigger"
        type="button"
        title="Open calendar"
        onClick={() => {
          if (!flatpickrRef?.current?.flatpickr) {
            return
          }

          const { flatpickr } = flatpickrRef.current
          flatpickr.toggle()
        }}
      >
        <SVGIcon
          className="date-picker-button__icon"
          xlinkHref="#streamline-calendar-list"
          alt="Private"
          pointerEvents="none"
        />
        <span className="sr-only">Open calendar</span>
      </button>
    </div>
  )
}

export default DatePickerButton
